import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { FormikProps } from 'formik';

import { IAllContractShifts, WorkshiftStatus } from '@pharmaplan/common';

import { nameTypes } from '../../../Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractTime/ViewEditContractTime';
import DateBox from '../../../Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractTime/DateBox';
import { getDayMonthDateYear } from '../../../../Reports/helpers';
import strings from '../../../../../localization';

import styles from './styles';
import ThemeConstants from '../../../../../theme/ThemeConstants';

const { start, end, dayOff } = nameTypes;

interface IRequestContractTimes {
  formik: FormikProps<any>;
  shifts: Array<IAllContractShifts>;
  counterShifts: Array<string>;

}

const RequestContractTimes: FC<IRequestContractTimes> = ({
  formik,
  shifts,
  counterShifts,
}) => {
  const requestedShifts = shifts?.filter(
    (item) =>
      item.status === WorkshiftStatus.Requested,
  );

  const { length } = requestedShifts ?? {};

  return (
    <Box>
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.selectRequestText}>
          {strings.formatString(
            strings.allRequestsWillBeCancelled,
            length ?? 0,
          )}
        </Typography>
      </Box>
      <Box sx={styles.dateBoxGrid}>
        {requestedShifts?.map?.((interval) => {
          const { startDate, status } = interval ?? {};
          const date = startDate?.split?.('T')?.[0];

          const isCounter = counterShifts.includes(date);

          return (
            <DateBox
              key={date}
              textColor={isCounter ? ThemeConstants.common.counterRed : null}
              showCheckbox={status === WorkshiftStatus.Posted}
              changedName={`${date}|${nameTypes.changed}`}
              title={`${getDayMonthDateYear(date)}`}
              dayOffName={`${date}|${dayOff}`}
              startName={`${date}|${start}`}
              endName={`${date}|${end}`}
              formik={formik}
              hideDayOff
              disabled
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default RequestContractTimes;
